import { format } from 'date-fns';
/**
 * The default ARIA label for the day button.
 */
export var labelDay = function (day, options) {
    return format(day, 'do MMMM (EEEE)', options);
};
//# sourceMappingURL=labelDay.js.map